import { takeEvery, put, call } from "redux-saga/effects";

// Login Redux States
import { LOGIN_REQUEST } from "./actionTypes";
import { loginSuccess, loginError } from "./actions";

import { LOGOUT_USER } from "../login/actionTypes";
import { LoginAPICall } from "APIs/Auth/ApiCalls";
import { Token } from "../../../firebaseInit";

function* loginUser({ payload: { data, history } }) {
  try {
    // call can be used to call a function
    const response = yield call(LoginAPICall, data);
    console.log(typeof response);
    localStorage.setItem("authUser", JSON.stringify(response));
    // put causes the action to be dispatched to the store
    // this action is then handled by the reducer
    // the reducer then updates the state
    // the state is then rendered to the screen
    // the screen is updated with the new state
    // This Action should not be watched by the saga
    yield put(loginSuccess(response));
    if (JSON.parse(localStorage.getItem("authUser")) !=null) {
      console.log("user in home",  JSON.parse(localStorage.getItem("authUser")));
      Token(JSON.parse(localStorage.getItem("authUser")));
      }
      else{
        console.log("user in home null", JSON.parse(localStorage.getItem("authUser")));
      }
    history.push("/dashboard"); // redirect to dashboard
  } catch (error) {
    console.log(error);
    yield put(loginError(error));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");
    history.push("/login");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* ProfilingSaga() {
  yield takeEvery(LOGIN_REQUEST, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default ProfilingSaga;
